import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      d: "M10 1H5.5L14 22l4 1z"
    }, null, -1),
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M18 20.074V1h-4.5v6.699zM5.5 3.665V23l4.5-1v-7.217z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const brandVideoNetflix = { render };
export {
  brandVideoNetflix as default,
  render
};
//# sourceMappingURL=brand-video-netflix.svg.js.map
